import React from "react";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminDataAssistanceRoutes from "./AdminDataAssistanceRoutes";

const AdminDataAssistanceScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Import Data Assistance",
      page: "Import Data Assistance Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminDataAssistanceRoutes />
      </Track>
    </div>
  );
};

export default AdminDataAssistanceScreen;
